import { render, staticRenderFns } from "./FeatureCompareTable.vue?vue&type=template&id=17ef7cbb&scoped=true&"
import script from "./FeatureCompareTable.vue?vue&type=script&lang=js&"
export * from "./FeatureCompareTable.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCompareTable.vue?vue&type=style&index=0&id=17ef7cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef7cbb",
  null
  
)

export default component.exports